import { render, staticRenderFns } from "./main-index.vue?vue&type=template&id=bb6eacbc&"
import script from "./main-index.vue?vue&type=script&lang=js&"
export * from "./main-index.vue?vue&type=script&lang=js&"
import style0 from "./main-index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports